import { defineComponent as E, openBlock as g, createBlock as N, unref as I, mergeProps as x, createSlots as L, withCtx as s, renderSlot as j, createElementBlock as a, Fragment as C, renderList as c, normalizeClass as Y, createVNode as T, createTextVNode as y, toDisplayString as h, createElementVNode as r, useCssVars as S, computed as p, withModifiers as z, createCommentVNode as n, resolveDynamicComponent as f, normalizeProps as B, guardReactiveProps as O, ref as k, reactive as b, onMounted as U, onBeforeUnmount as v, normalizeStyle as H } from "vue";
import { a as u, c as d, _ as Q, S as P, C as _ } from "./NavigationDrawer.vue_vue_type_style_index_1_scoped_fd5bf7fb_lang-a9e75722.mjs";
import { V as w, a as G } from "./VFooter-c3bcfdb6.mjs";
import { Z as $ } from "./VTextarea-a9029832.mjs";
const R = ["href"], V = ["src"], F = /* @__PURE__ */ y("Log In"), Z = /* @__PURE__ */ y("Sign Up"), K = /* @__PURE__ */ E({
  props: {
    headerHeight: {
      type: Number,
      default: 60
    },
    showMenu: {
      type: Boolean,
      default: !1
    },
    color: {
      type: String,
      default: "highlight-side-panel"
    },
    outline: {
      type: Boolean,
      default: !1
    },
    headerUnderneath: {
      type: Boolean,
      default: !1
    },
    logoHref: {
      type: String,
      default: "/"
    },
    links: {
      type: Array,
      default: () => []
    },
    activeLink: {
      type: String,
      default: ""
    },
    underlineEffect: {
      type: Boolean,
      default: !1
    },
    navigation: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["logIn", "signUp", "logoClicked"],
  setup(i, { emit: t }) {
    const A = i, { width: l } = $();
    return (M, e) => (g(), N(I(w), x({
      height: A.headerHeight,
      color: A.color,
      flat: ""
    }, M.$slots, {
      class: [
        "app-bar",
        {
          "app-bar--outlined": A.outline,
          "app-bar--drawer": A.navigation
        }
      ]
    }), L({
      extension: s(() => [
        j(M.$slots, "header-extension", {}, void 0, !0)
      ]),
      append: s(() => [
        j(M.$slots, "header-links", {}, () => [
          (g(!0), a(C, null, c(A.links, (o) => (g(), a("div", {
            key: o.href,
            class: Y([
              "app-bar__button mr-0",
              { "mr-3": I(l) > 850 },
              { "mr-6": I(l) > 900 },
              { "mr-8": I(l) > 950 },
              {
                "active-border": i.activeLink === o.href && i.underlineEffect && !o.buttonMode
              }
            ])
          }, [
            T(u, {
              size: o.buttonMode ? "default" : "small",
              plain: o.buttonMode ? void 0 : !0,
              "prepend-icon": o.icon,
              href: o.href,
              "text-color": i.activeLink === o.href ? "copy-primary" : "copy-secondary",
              mode: o.buttonMode || void 0,
              target: o.target
            }, {
              default: s(() => [
                y(h(o.label), 1)
              ]),
              _: 2
            }, 1032, ["size", "plain", "prepend-icon", "href", "text-color", "mode", "target"])
          ], 2))), 128)),
          T(u, {
            size: "small",
            plain: "",
            class: "mr-4",
            onClick: e[1] || (e[1] = (o) => t("logIn"))
          }, {
            default: s(() => [
              F
            ]),
            _: 1
          }),
          T(u, {
            size: "default",
            onClick: e[2] || (e[2] = (o) => t("signUp"))
          }, {
            default: s(() => [
              Z
            ]),
            _: 1
          })
        ], !0)
      ]),
      _: 2
    }, [
      A.headerUnderneath ? void 0 : {
        name: "prepend",
        fn: s(() => [
          r("a", {
            onClick: e[0] || (e[0] = (o) => t("logoClicked")),
            href: A.logoHref,
            target: "_self",
            class: "d-flex",
            style: { height: "22px" }
          }, [
            j(M.$slots, "custom-logo", {}, () => [
              r("img", {
                alt: "logo",
                src: I(d)
              }, null, 8, V)
            ], !0)
          ], 8, R)
        ])
      }
    ]), 1040, ["height", "color", "class"]));
  }
});
const X = /* @__PURE__ */ Q(K, [["__scopeId", "data-v-71b1d960"]]), W = ["href"], J = ["src"], q = {
  key: 0,
  class: "align-center d-flex justify-center w-100"
}, AA = ["href"], eA = ["src"], MA = /* @__PURE__ */ E({
  props: {
    headerHeight: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: "highlight-side-panel"
    },
    outline: {
      type: Boolean,
      default: !1
    },
    headerUnderneath: {
      type: Boolean,
      default: !1
    },
    logoHref: {
      type: String,
      default: "/"
    },
    mobileLeftHamburger: {
      type: Boolean,
      default: !1
    },
    mobileCenterHeaderLogo: {
      type: Boolean,
      default: !1
    },
    showMobileMenuButtons: {
      type: Boolean,
      default: !0
    },
    showClose: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "menuClicked",
    "closeClicked",
    "logOut",
    "logoClicked"
  ],
  setup(i, { emit: t }) {
    const A = i;
    S((M) => ({
      b918f192: I(l)
    }));
    const l = p(() => A.mobileLeftHamburger ? "0px" : "32px");
    return (M, e) => (g(), N(I(w), x({
      height: A.headerHeight,
      color: A.color,
      flat: ""
    }, M.$attrs, {
      class: ["app-bar", { "app-bar--outlined": A.outline }]
    }), {
      extension: s(() => [
        j(M.$slots, "header-extension", {}, void 0, !0)
      ]),
      prepend: s(() => [
        A.mobileLeftHamburger && !A.showClose && A.showMobileMenuButtons ? (g(), N(u, {
          key: 0,
          onClick: e[0] || (e[0] = z((o) => M.$emit("menuClicked"), ["stop"])),
          class: "mx-3",
          "icon-height": "40",
          icon: "ph:list",
          size: "small",
          "icon-color": "rgb(var(--v-theme-highlight-panel))",
          plain: ""
        })) : n("", !0),
        A.mobileLeftHamburger && A.showClose && A.showMobileMenuButtons ? (g(), N(u, {
          key: 1,
          onClick: e[1] || (e[1] = z((o) => M.$emit("closeClicked"), ["stop"])),
          class: "mx-3",
          "icon-height": "40",
          icon: "ph:x",
          size: "small",
          plain: "",
          "icon-color": "rgb(var(--v-theme-highlight-panel))"
        })) : n("", !0),
        A.mobileCenterHeaderLogo ? n("", !0) : (g(), a("a", {
          key: 2,
          href: A.logoHref,
          target: "_self",
          class: "d-flex",
          style: { height: "22px" }
        }, [
          j(M.$slots, "custom-logo", {}, () => [
            r("img", {
              alt: "logo",
              src: I(d)
            }, null, 8, J)
          ], !0)
        ], 8, W))
      ]),
      append: s(() => [
        j(M.$slots, "mobile-link", {}, void 0, !0),
        !A.mobileLeftHamburger && !A.showClose && A.showMobileMenuButtons ? (g(), N(u, {
          key: 0,
          onClick: e[3] || (e[3] = z((o) => M.$emit("menuClicked"), ["stop"])),
          "icon-height": "32",
          icon: "ph:list",
          "icon-color": "rgb(var(--v-theme-highlight-panel))"
        })) : n("", !0),
        !A.mobileLeftHamburger && M.$attrs.location !== "right" && A.showClose && A.showMobileMenuButtons ? (g(), N(u, {
          key: 1,
          onClick: e[4] || (e[4] = z((o) => M.$emit("closeClicked"), ["stop"])),
          "icon-height": "32",
          icon: "ph:x",
          "icon-color": "rgb(var(--v-theme-highlight-panel))"
        })) : n("", !0)
      ]),
      default: s(() => [
        A.mobileCenterHeaderLogo ? (g(), a("div", q, [
          r("a", {
            href: A.logoHref,
            onClick: e[2] || (e[2] = (o) => t("logoClicked")),
            target: "_self",
            class: "d-flex",
            style: { height: "22px" }
          }, [
            j(M.$slots, "custom-logo", {}, () => [
              r("img", {
                alt: "logo",
                src: I(d)
              }, null, 8, eA)
            ], !0)
          ], 8, AA)
        ])) : n("", !0)
      ]),
      _: 3
    }, 16, ["height", "color", "class"]));
  }
});
const oA = /* @__PURE__ */ Q(MA, [["__scopeId", "data-v-aa24660a"]]), dA = /* @__PURE__ */ E({
  props: {
    mobile: {
      type: Boolean,
      default: !1
    }
  },
  setup(i) {
    const t = i;
    return (A, l) => (g(), N(f(t.mobile ? oA : X), null, L({
      default: s(() => [
        j(A.$slots, "default")
      ]),
      _: 2
    }, [
      c(Object.keys(A.$slots), (M) => ({
        name: M,
        fn: s((e) => [
          j(A.$slots, M, B(O(e)))
        ])
      }))
    ]), 1024));
  }
}), gA = "data:image/svg+xml;base64,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", tA = "data:image/png;base64,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", sA = ["src"], IA = { class: "footer ma-0 pa-0" }, jA = ["src"], iA = { class: "footer__content" }, lA = {
  class: "d-flex footer__content-logo justify-center",
  style: { height: "22px" }
}, rA = ["src"], NA = {
  key: 0,
  class: "align-center d-flex"
}, aA = { key: 1 }, nA = {
  key: 0,
  class: "px-3"
}, DA = /* @__PURE__ */ y(" © 2024 charactr, Inc. All rights reserved"), uA = /* @__PURE__ */ E({
  props: {
    footerHeight: {
      type: Number,
      default: 400
    },
    hideLogo: {
      type: Boolean,
      default: !1
    },
    links: {
      type: Array,
      default: () => []
    },
    socialMediaLinks: {
      type: Array,
      default: P
    },
    showSocialMedia: {
      type: Boolean,
      default: !0
    },
    showLinks: {
      type: Boolean,
      default: !0
    }
  },
  setup(i) {
    const t = i, A = k(), l = b({
      height: 0,
      resizeObserver: {}
    });
    U(() => {
      t.hideLogo || (l.resizeObserver = new ResizeObserver((e) => {
        for (const o of e)
          l.height = o.contentRect.height;
      }), l.resizeObserver.observe(A.value));
    }), v(() => {
      t.hideLogo || l.resizeObserver.disconnect();
    });
    const M = p(() => 280 - l.height / 2);
    return (e, o) => (g(), N(I(G), x({
      height: t.footerHeight,
      class: "align-end ma-0 pa-0"
    }, e.$attrs, {
      absolute: "",
      app: "",
      outline: ""
    }), {
      default: s(() => [
        t.hideLogo ? n("", !0) : (g(), a("div", {
          key: 0,
          ref_key: "footerTopLogoImg",
          ref: A,
          style: H({ bottom: `${I(M)}px` }),
          class: "d-flex footer-top-logo"
        }, [
          j(e.$slots, "custom-top-footer", {}, () => [
            r("img", { src: I(gA) }, null, 8, sA)
          ], !0)
        ], 4)),
        r("div", IA, [
          r("div", null, [
            r("img", {
              class: "footer__img",
              src: I(tA)
            }, null, 8, jA)
          ]),
          r("div", iA, [
            r("div", lA, [
              j(e.$slots, "custom-logo-footer", {}, () => [
                r("img", {
                  alt: "logo",
                  src: I(d)
                }, null, 8, rA)
              ], !0)
            ]),
            t.showSocialMedia ? (g(), a("div", NA, [
              j(e.$slots, "footer-social-media", {}, () => [
                (g(!0), a(C, null, c(t.socialMediaLinks, (D) => (g(), N(u, {
                  size: "x-small",
                  class: "px-6 social-media-button",
                  plain: "",
                  key: D.href,
                  href: D.href,
                  icon: D.icon,
                  "icon-height": "24",
                  target: D.target,
                  "icon-color": "rgb(var(--v-theme-highlight-color))"
                }, null, 8, ["href", "icon", "target"]))), 128))
              ], !0)
            ])) : n("", !0),
            t.showLinks ? (g(), a("div", aA, [
              j(e.$slots, "footer-links", {}, () => [
                (g(!0), a(C, null, c(t.links, (D, m) => (g(), N(u, {
                  size: "small",
                  plain: "",
                  class: "ma-0 pa-0",
                  key: D.href,
                  href: D.href,
                  "typography-variant": "body-2-400",
                  "text-color": "copy-secondary",
                  target: D.target
                }, {
                  default: s(() => [
                    y(h(D.label) + " ", 1),
                    m !== i.links.length - 1 ? (g(), a("span", nA, "•")) : n("", !0)
                  ]),
                  _: 2
                }, 1032, ["href", "target"]))), 128))
              ], !0)
            ])) : n("", !0),
            T(_, {
              class: "footer__content-info py-1",
              "color-class": "copy-tertiary",
              variant: "body-3-400"
            }, {
              default: s(() => [
                DA
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 3
    }, 16, ["height"]));
  }
});
const cA = /* @__PURE__ */ Q(uA, [["__scopeId", "data-v-32a53854"]]), CA = /* @__PURE__ */ E({
  props: {
    extended: {
      type: Boolean,
      default: !0
    }
  },
  setup(i) {
    const t = cA;
    return (A, l) => (g(), N(f(i.extended && I(t)), null, L({
      default: s(() => [
        j(A.$slots, "default")
      ]),
      _: 2
    }, [
      c(Object.keys(A.$slots), (M) => ({
        name: M,
        fn: s((e) => [
          j(A.$slots, M, B(O(e)))
        ])
      }))
    ]), 1024));
  }
});
export {
  dA as _,
  CA as a
};
